import { render, staticRenderFns } from "./ForgotPasswordDialog.vue?vue&type=template&id=6b58ce7a"
import script from "./ForgotPasswordDialog.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b58ce7a')) {
      api.createRecord('6b58ce7a', component.options)
    } else {
      api.reload('6b58ce7a', component.options)
    }
    module.hot.accept("./ForgotPasswordDialog.vue?vue&type=template&id=6b58ce7a", function () {
      api.rerender('6b58ce7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/ForgotPasswordDialog.vue"
export default component.exports